import { useState } from "react";
import client from "@/api";
import { useApp } from "@/context/AppContext";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Shield } from "lucide-react";
import { PasswordInput } from "@/components/PasswordInput";

export default function AdminLogin() {
  const { t, setUser, setAccessStatus } = useApp();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await client.post("/auth/admin/login", { email, password });
      setUser(data.user); setAccessStatus(data.access_status);
      navigate(data.user.role === "admin" ? "/admin" : "/dashboard", { state: { user: data.user } });
    } catch (e) {
      toast.error(e.response?.data?.detail || t("error"));
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0d0d0d] px-4 bg-grain">
      <form onSubmit={submit} className="card-dark rounded-2xl p-8 w-full max-w-md" data-testid="admin-login-form">
        <div className="flex items-center gap-3 mb-6">
          <Shield className="w-7 h-7 text-[#D21F2A]" />
          <h1 className="font-serif text-2xl text-[#FFFFFF]">{t("admin_login_title")}</h1>
        </div>
        <label className="block text-xs uppercase tracking-wider text-[#C9CDD3] mb-1">{t("email")}</label>
        <input data-testid="admin-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
          className="focusable w-full mb-4 px-4 py-3 rounded-lg bg-[#141414] border border-[#D21F2A]/20 text-[#FFFFFF]" />
        <label className="block text-xs uppercase tracking-wider text-[#C9CDD3] mb-1">{t("password")}</label>
        <div className="mb-6"><PasswordInput testid="admin-password-input" value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="current-password" /></div>
        <button data-testid="admin-login-submit" disabled={busy} type="submit"
          className="btn-gold focusable w-full py-3 rounded-lg">{busy ? t("loading") : t("login")}</button>
      </form>
    </div>
  );
}
